import { render, staticRenderFns } from "./ServiceDetails.vue?vue&type=template&id=479651dd&scoped=true&"
import script from "./ServiceDetails.vue?vue&type=script&lang=js&"
export * from "./ServiceDetails.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDetails.vue?vue&type=style&index=0&id=479651dd&prod&scoped=true&lang=css&"
import style1 from "./ServiceDetails.vue?vue&type=style&index=1&id=479651dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479651dd",
  null
  
)

export default component.exports